import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/table/index.js
// module id = 788
// module chunks = 1